module.exports = __webpack_public_path__ + "static/img/IMG_20151021_224744.4771a827.jpg";